module.exports = __webpack_public_path__ + "static/media/radio-1-norm.9d01d598.svg";